import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChildren,
  AfterViewInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@/app/services/auth/authentication.service';
import { NgToastService } from 'ng-angular-popup';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AuthHeaderComponent } from '../../global/auth-header/auth-header.component';
import { ApiErrorResponse } from '@/app/interfaces/api-error-response.interface';
import { MessagesEnum } from '@/app/ enums/message.enum';
import { MatIconModule } from '@angular/material/icon';

export interface verifyOtpResponse {
  success: boolean | null;
  msg: string | null;
}
export interface OrganizationInfo {
  id?: number | null;
  name?: string | null;
  title?: string | null;
  email?: string | null;
  phone?: string | null;
  is_owner?: boolean | null;
  created_at?: string | null;
  updated_at?: string | null;
}

@Component({
  selector: 'app-verification',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AuthHeaderComponent,
    MatIconModule,
  ],
  templateUrl: './verification.component.html',
  styleUrl: './verification.component.css',
})
export class VerificationComponent implements OnInit, AfterViewInit {
  isHidden: boolean = false;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthenticationService,
    private toast: NgToastService
  ) {
    this.verificationForm = this.fb.group({
      digit1: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
      digit2: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
      digit3: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
      digit4: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
      digit5: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
      digit6: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
    });
  }
  @ViewChildren('otpInput') otpInputs!: QueryList<ElementRef>;

  isSendingOtp: boolean = false;
  isFadeOut: boolean = false;
  countdown: number;
  isShowOtpMessage: boolean = false;
  verificationForm: FormGroup;
  org_info: OrganizationInfo;
  otpArray: number[] = [1, 2, 3, 4, 5, 6];
  invalidOtpMessage = '';
  successOtpMessage = '';

  ngOnInit() {
    this.fetchOrgInfo();
    this.listenForOtpCompletion();
  }
  ngAfterViewInit() {
    const firstInput = this.otpInputs.first;
    if (firstInput) {
      firstInput.nativeElement.focus();
    }
  }
  fetchOrgInfo() {
    const data = localStorage.getItem('org_info');
    this.org_info = JSON.parse(data);
  }

  listenForOtpCompletion() {
    this.verificationForm.valueChanges.subscribe(() => {
      const isComplete = Object.values(this.verificationForm.value).every(
        (digit: any) => digit && digit.length === 1
      );

      if (isComplete) {
        this.verifyOtp();
      }
    });
  }

  onKey(event: any, nextInput: ElementRef, prevInput?: ElementRef) {
    const inputValue = event.target.value;
    if (inputValue && nextInput) {
      nextInput.nativeElement.focus();
    } else if (!inputValue && prevInput) {
      prevInput.nativeElement.focus();
    }
  }

  resendCode() {
    this.authService.resendOtp(this.org_info.id).subscribe({
      next: (response: verifyOtpResponse) => {
        if (response.success) {
          this.successOtpMessage = '';
          this.invalidOtpMessage = '';
          this.isShowOtpMessage = true;
          this.isFadeOut = false;
          this.countdown = 13;
          this.isHidden = false; // Ensure element is visible at the start

          // Countdown logic
          const countdownInterval = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0) {
              clearInterval(countdownInterval); // Stop the countdown
              this.isHidden = true; // Hide the countdown element
            }
          }, 1000);

          // Set a timeout to hide the message
          setTimeout(() => {
            this.isFadeOut = true; // Add fade-out class
            setTimeout(() => {
              this.isShowOtpMessage = false; // Hide the message completely
            }, 300);
          }, 3000);
        } else {
          this.isShowOtpMessage = false;
          this.toast.danger(response.msg, 'SUCCESS', 4000);
        }
      },
      error: (error: ApiErrorResponse) => {
        console.error('Login failed:', error);
        this.toast.danger(MessagesEnum.UNABLE_RESENT_OTP, 'DANGER', 4000);
      },
    });
  }
  verifyOtp() {
    if (this.verificationForm.invalid) {
      this.verificationForm.markAllAsTouched();
      this.toast.danger(MessagesEnum.OTP_REQUIRED, 'DANGER', 4000);
      return;
    }
    const otp = Object.values(this.verificationForm.value).join('');
    const dataToSubmit = {
      email: this.org_info.email,
      otp: Number(otp),
    };
    this.isSendingOtp = true;
    this.authService.verifyOtp(dataToSubmit).subscribe({
      next: (response: verifyOtpResponse) => {
        this.isSendingOtp = false;
        if (response.success) {
          this.toast.success(response.msg, 'SUCCESS', 4000);
          this.successOtpMessage = '"Success! Your code has been verified."';
          setTimeout(() => {
            this.router.navigate(['/paymentplan']);
          }, 2000); //
        } else {
          this.toast.danger(response.msg, 'SUCCESS', 4000);
          this.invalidOtpMessage =
            'Error! The code you entered is incorrect. Please try again.';
        }
      },
      error: (error: ApiErrorResponse) => {
        console.error('Login failed:', error);
        this.toast.danger(MessagesEnum.UNABLE_VERIFY_OTP, 'DANGER', 4000);
      },
    });
  }
  navigateTo() {
    this.router.navigate(['/register']);
  }
}
